<template>
    <div class="dashboard-container">
        <!-- 群组选择弹窗 -->
        <GroupSelector v-model="showGroupSelector" @group-selected="onGroupSelected"
            @groups-loaded="handleGroupsLoaded" />

        <!-- 数据加载中的骨架屏 -->
        <div v-if="loading">
            <div class="dashboard-flex-row">
                <el-card class="dashboard-card" v-for="i in 3" :key="'today-' + i">
                    <el-skeleton :loading="true" animated>
                        <template #template>
                            <div class="card-title">
                                <el-skeleton-item variant="text" style="width: 80%; height: 16px;" />
                            </div>
                            <div class="card-value">
                                <el-skeleton-item variant="text" style="width: 60%; height: 32px;" />
                            </div>
                        </template>
                    </el-skeleton>
                </el-card>
            </div>
            <div class="dashboard-flex-row">
                <el-card class="dashboard-card" v-for="i in 3" :key="'yesterday-' + i">
                    <el-skeleton :loading="true" animated>
                        <template #template>
                            <div class="card-title">
                                <el-skeleton-item variant="text" style="width: 80%; height: 16px;" />
                            </div>
                            <div class="card-value">
                                <el-skeleton-item variant="text" style="width: 60%; height: 32px;" />
                            </div>
                        </template>
                    </el-skeleton>
                </el-card>
            </div>
        </div>

        <!-- 实际数据 -->
        <div v-else>
            <div class="dashboard-flex-row">
                <el-card class="dashboard-card">
                    <div class="card-title">今日进群用户数</div>
                    <div class="card-value">{{ stats.todayJoin }}</div>
                </el-card>
                <el-card class="dashboard-card">
                    <div class="card-title">今日退群用户数</div>
                    <div class="card-value">{{ stats.todayLeft }}</div>
                </el-card>
                <el-card class="dashboard-card">
                    <div class="card-title">今日活跃用户数</div>
                    <div class="card-value">{{ stats.todayActive || 0 }}</div>
                </el-card>
            </div>

            <div class="dashboard-flex-row">
                <el-card class="dashboard-card">
                    <div class="card-title">昨日进群用户数</div>
                    <div class="card-value">{{ stats.yesterdayJoin }}</div>
                </el-card>
                <el-card class="dashboard-card">
                    <div class="card-title">昨日退群用户数</div>
                    <div class="card-value">{{ stats.yesterdayLeft }}</div>
                </el-card>
                <el-card class="dashboard-card">
                    <div class="card-title">昨日活跃用户数</div>
                    <div class="card-value">{{ stats.yesterdayActive || 0 }}</div>
                </el-card>
            </div>
        </div>








        <!-- 当前群组信息 -->
        <el-row :gutter="20" class="dashboard-section" v-if="currentGroup">
            <el-col :span="24">
                <el-card class="current-group-card">
                    <div class="group-info">
                        <el-icon class="group-icon">
                            <ChatDotRound />
                        </el-icon>
                        <div class="group-details">
                            <h3>当前管理群组：{{ currentGroup.grouptitle }}</h3>
                            <p>群组ID：{{ currentGroup.groupid }} | 状态：{{ currentGroup.status === 1 ? '活跃' :
                                currentGroup.status === 2 ? '备份' : '禁用' }}</p>
                        </div>
                        <div class="group-actions">
                        <el-button type="primary" @click="showGroupSelector = true">
                            切换群组
                        </el-button>
                            <el-button type="success" @click="refresh" :loading="loading" :disabled="loading">
                                <el-icon>
                                    <Refresh />
                                </el-icon>
                                刷新数据
                            </el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="dashboard-section">
            <el-col :span="12">
                <el-card>
                    <div class="section-title">最近登录用户</div>
                    <el-table :data="recentLogins" style="width: 100%" size="small" v-loading="loading">
                        <el-table-column prop="username" label="用户名" width="120" />
                        <el-table-column prop="loginTime" label="登录时间" width="180" />
                        <el-table-column prop="ip" label="IP地址" />
                    </el-table>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card>
                    <div class="section-title">最近操作记录</div>
                    <el-table :data="recentActions" style="width: 100%" size="small" v-loading="loading">
                        <el-table-column prop="username" label="用户名" width="120" />
                        <el-table-column prop="action" label="操作" />
                        <el-table-column prop="time" label="时间" width="180" />
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { ChatDotRound, Refresh } from '@element-plus/icons-vue'
import GroupSelector from './GroupSelector.vue'
import api from '@/services/api'

export default {
    name: 'Dashboard',
    components: {
        ChatDotRound,
        Refresh,
        GroupSelector
    },
    data() {
        return {
            showGroupSelector: false,
            loading: false,
            stats: {
                todayJoin: 0,
                todayLeft: 0,
                yesterdayJoin: 0,
                yesterdayLeft: 0,
                todayActive: 0,
                yesterdayActive: 0
            },
            recentLogins: [],
            recentActions: [],
            // 从 GroupSelector 接收的群组数据
            availableGroups: []
        }
    },
    computed: {
        currentGroup() {
            const groupId = this.$store.state.user?.groupId || localStorage.getItem('groupId');
            if (groupId && groupId > 0) {
                return this.availableGroups.find(group => group.id === parseInt(groupId));
            }
            return null;
        }
    },
    mounted() {
        this.checkGroupSelection();
        this.refresh();
    },
    methods: {
        async refresh() {
            // 获取当前群组ID
            const groupId = this.$store.state.user?.groupId || localStorage.getItem('groupId');
            if (!groupId || groupId === '0') return;

            this.loading = true;
            try {
                // 拉取合并的统计数据
                const statsRes = await api.getDashboardStats(groupId);
                this.stats = statsRes.data;

                console.log('[Dashboard.refresh] 数据已刷新', this.stats);
            } catch (e) {
                console.error('[Dashboard.refresh] 刷新失败', e);
                this.$message.error('获取数据失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },
        checkGroupSelection() {
            const groupId = this.$store.state.user?.groupId || localStorage.getItem('groupId');
            // 如果 groupId 为 0 或未设置，强制显示群组选择弹窗
            if (!groupId || groupId === '0') {
                this.showGroupSelector = true;
            }
        },
        onGroupSelected(group) {
            // 向父组件（Admin.vue）冒泡事件
            this.$emit('group-selected', group);
            // 切换群后强制刷新
            this.refresh();
        },
        handleGroupsLoaded(groups) {
            // 接收来自 GroupSelector 的群组数据
            this.availableGroups = groups;
        }
    }
}
</script>

<style scoped>
.dashboard-container {
    padding: 24px;
    background: var(--main-bg-color, #f6f8fc);
}

.dashboard-flex-row {
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
}

.dashboard-card {
    flex: 1;
    text-align: center;
    background: var(--sidebar-bg-color, #fff);
    border: none;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.04);
}

.card-title {
    font-size: 15px;
    color: #888;
    margin-bottom: 8px;
}

.card-value {
    font-size: 32px;
    font-weight: bold;
    color: var(--el-color-primary, #626aef);
}

.dashboard-section {
    margin-bottom: 24px;
}

.current-group-card {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 1px solid #bae6fd;
}

.group-info {
    display: flex;
    align-items: center;
    padding: 16px 0;
}

.group-icon {
    font-size: 24px;
    color: #0088cc;
    margin-right: 16px;
}

.group-details {
    flex: 1;
}

.group-details h3 {
    margin: 0 0 4px 0;
    font-size: 16px;
    color: #333;
}

.group-details p {
    margin: 0;
    font-size: 14px;
    color: #666;
}

.group-actions {
    display: flex;
    gap: 12px;
    align-items: center;
}

.section-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    color: #333;
}

/* 加载状态样式 */
.dashboard-flex-row .el-skeleton {
    padding: 20px;
}

.dashboard-flex-row .el-skeleton .card-title {
    margin-bottom: 8px;
}

.dashboard-flex-row .el-skeleton .card-value {
    margin-top: 8px;
}

/* 数据加载动画 */
.dashboard-container .el-skeleton__item {
    background: linear-gradient(90deg, #f2f2f2 25%, rgba(255, 255, 255, 0.8) 50%, #f2f2f2 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}
</style>